import moment from 'moment';
import 'moment/dist/locale/ru';
import z from "zod";

moment.locale('ru');
z.config(z.locales.ru());